module.exports = __webpack_public_path__ + "img/google-play-jp.a6b4afe9.png";